import Country from "@/domains/Countries/Country";

const isSellerResolver = (oldValue: boolean, newValue: boolean) =>
    newValue ? ' - партнер стал продавцом' : ' - партнер больше не продавец';

const isBuyerResolver = (oldValue: boolean, newValue: boolean) =>
    newValue ? ' - партнер стал покупателем' : ' - партнер больше не покупатель';

const isDelivererResolver = (oldValue: boolean, newValue: boolean) =>
    newValue ? ' - партнер стал транспортной компанией' : ' - партнер больше не транспортная компания';

const isOperationsAllowed = (oldValue: boolean, newValue: boolean) =>
    newValue ? ' - открыт полный доступ' : ' - установлен тестовый доступ';

const countryResolver = (oldValue: Country, newValue: Country) => {
		if (newValue) {
			return ` с "${oldValue.name}" <b>на</b> "${newValue.name}"`;
		}
};

export {
    isSellerResolver,
    isBuyerResolver,
    isDelivererResolver,
    isOperationsAllowed,
		countryResolver,
}
